<template>
  <div class="summary-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="客诉时间">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="售后原因">
              <el-cascader v-model="searchForm.reason" :props="manySelect" style="width:500px" :options="afterReasonOption" filterable clearable></el-cascader>
            </el-form-item>
            <br/>
            <el-form-item label="责任部门">
              <el-select v-model="searchForm.depts" style="width:440px;" clearable multiple placeholder="选择部门" >
                <el-option v-for="d in afterReasonOption" :label="d.label" :value="d.value">{{d.label}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"/>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :loading="excelLoading" icon="el-icon-document" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="客诉时间"
                    prop="time"
                    align="center"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    label="订单号"
                    prop="ordernum"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    label="原生产单号"
                    prop="beforenum"
                    align="center"
                    show-overflow-tooltip
                    width="100">
                  </el-table-column>
                  <el-table-column
                    label="客户名称"
                    prop="delname"
                    align="center"
                    show-overflow-tooltip
                    width="100">
                    <template slot-scope="scope">
                      <span :style="scope.row.delname && scope.row.delname.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.delname }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="终端地址"
                    prop="address"
                    align="center"
                    show-overflow-tooltip
                    width="130">
                  </el-table-column>
                  <el-table-column
                    label="责任车间"
                    align="center"
                    prop="factory"
                    show-overflow-tooltip
                    width="90">
                  </el-table-column>
                  <el-table-column
                    label="正单金额"
                    prop="orderamount"
                    align="center"
                    show-overflow-tooltip
                    width="90">
                  </el-table-column>
                  <el-table-column
                    label="设计师"
                    prop="designer"
                    align="center"
                    show-overflow-tooltip
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="客服"
                    prop="service"
                    align="center"
                    show-overflow-tooltip
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="处理状态"
                    width="80"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="warning">待处理</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1">已处理</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2" type="danger">已驳回</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="处理人"
                    prop="opername"
                    align="center"
                    show-overflow-tooltip
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="处理时间"
                    prop="opertime"
                    align="center"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    label="售后投诉内容"
                    prop="content"
                    align="center"
                    show-overflow-tooltip
                    min-width="140">
                  </el-table-column>
                  <el-table-column
                    label="售后原因"
                    prop="rson"
                    align="center"
                    show-overflow-tooltip
                    width="120">
                  </el-table-column>
                  <el-table-column
                    label="不良数量"
                    prop="badnum"
                    align="center"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="责任部门"
                    prop="dept"
                    align="center"
                    show-overflow-tooltip
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="赔款金额"
                    prop="indemnity"
                    align="center"
                    show-overflow-tooltip
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="重做金额"
                    prop="redo"
                    align="center"
                    show-overflow-tooltip
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="备注"
                    prop="remark"
                    align="center"
                    show-overflow-tooltip
                    width="140">
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    width="120"-->
<!--                    fixed="right"-->
<!--                    align="center"-->
<!--                    label="操作">-->
<!--                    <template slot-scope="scope">-->
<!--                      <el-button size="mini" @click.stop="view(scope.row)" icon="el-icon-search">查看详情</el-button>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="售后处理详情"
      :visible.sync="infoVisible"
      width="762px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="fullscreenLoading">
        <tr>
          <th>订单号</th>
          <td>{{infoData.order.ordernum}}</td>
          <th>原正单号</th>
          <td>{{infoData.order.beforenum}}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{infoData.order.all_name}}</td>
          <th>生产车间</th>
          <td>{{infoData.order.product_factory}}</td>
        </tr>
        <tr>
          <th>设计师</th>
          <td>{{infoData.sjsname}}</td>
          <th>客服</th>
          <td>{{infoData.kfname}}</td>
        </tr>
        <tr>
          <th>客诉时间</th>
          <td>{{infoData.order.time}}</td>
          <th>订单总额</th>
          <td>{{infoData.orderamount}}</td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="3">{{infoData.order.address}}</td>
        </tr>
        <tr>
          <th>投诉内容</th>
          <td colspan="3">{{infoData.afterSale.content}}</td>
        </tr>
        <tr>
          <th>返修单</th>
          <td colspan="3">
            <span @click="downFile(infoData.afterSale.reworkid)" class="tcf-link"><i class="el-icon-download"></i> {{infoData.afterSale.reworkname}}</span>
          </td>
        </tr>
        <tr>
          <th>判定单</th>
          <td colspan="3">
            <el-image
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[infoData.afterSale.decision_url]"
              :src="infoData.afterSale.decision_url">
            </el-image>
          </td>
        </tr>
        <tr>
          <th style="width:80px">责任部门<br>售后原因</th>
          <td colspan="3">
            <el-table
              size="mini"
              :data="infoData.deptRson"
              style="width: 100%">
              <el-table-column
                prop="deptname"
                label="责任部门"
                align="center"
                width="100"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="rsonname"
                label="售后原因"
                align="center"
                width="130"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="num"
                label="不良数量"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="amount"
                label="费用"
                align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="remark"
                align="center"
                label="备注"
                show-overflow-tooltip>
              </el-table-column>
            </el-table>

          </td>
        </tr>
        <tr>
          <th>责任车间</th>
          <td>{{infoData.factory}}</td>
          <th>售后赔款</th>
          <td>{{infoData.afterSale.amount}}&nbsp;元</td>
        </tr>
        <tr>
          <th>售后备注</th>
          <td colspan="3">{{infoData.afterSale.remark}}</td>
        </tr>
        <tr>
          <th>处理人</th>
          <td>{{infoData.afterSale.username}}</td>
          <th>处理时间</th>
          <td>{{infoData.afterSale.opertime}}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="infoVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { getUser } from '@/utils/auth'
import { getAfterSummaryList, exportAfterSummaryList, getAfterReason, getAfterSalePageInfo } from '@/api/erp'

export default {
  name: 'shhz',
  data() {
    return {
      manySelect: { multiple: true },
      searchForm: {
        search: '',
        time: [],
        depts: [],
        reason: []
      },
      tableData: [],
      total: 0,
      pageSize: 20,
      currentPage: 1,
      loading: false,
      excelLoading: false,
      afterReasonOption: [],
      fullscreenLoading: false,
      infoVisible: false,
      infoData: {
        rson: '',
        factory: '',
        deptRson: [],
        sjsname: '',
        kfname: '',
        orderamount: 0.0,
        order: {
          ordernum: null,
          beforenum: null,
          time: null,
          all_name: null,
          address: null,
          product_factory: null
        },
        afterSale: {
          decision_url: null,
          content: null,
          reworkname: null,
          reworkid: null,
          remark: null,
          amount: null,
          opertime: null,
          username: null
        }
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    getAfterReason().then(response => {
      let afterReasonOption = []
      for (let r of response.data) {
        let children = []
        for (let a of r.list) {
          children.push({ value: a.rid, label: a.name })
        }
        afterReasonOption.push({ value: r.arid, label: r.name, children: children })
      }
      this.afterReasonOption = afterReasonOption
    }).catch(() => {})
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const reasonArr = []
      for (let i = 0; i < this.searchForm.reason.length; i++) {
        reasonArr.push(this.searchForm.reason[i][1])
      }
      const data = {
        keyword: this.searchForm.search,
        startTime: startTime,
        endTime: endTime,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        page: this.currentPage,
        limit: this.pageSize,
        depts: this.searchForm.depts.join(','),
        reason: reasonArr.join(',')
      }
      this.loading = true
      getAfterSummaryList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    exportExcel() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const reasonArr = []
      for (let i = 0; i < this.searchForm.reason.length; i++) {
        reasonArr.push(this.searchForm.reason[i][1])
      }
      const data = {
        keyword: this.searchForm.search,
        startTime: startTime,
        endTime: endTime,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        depts: this.searchForm.depts.join(','),
        reason: reasonArr.join(',')
      }
      this.excelLoading = true
      exportAfterSummaryList(data).then(response => {
        const _this = this
        let xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          _this.excelLoading = false
          if (this.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      }).catch(() => {
        this.excelLoading = false
      })
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    view(row) {
      this.fullscreenLoading = true
      this.infoData.deptRson = []
      getAfterSalePageInfo({ afterid: row.asid }).then(response => {
        this.infoData = response.data
        this.infoData.sjsname = row.sjsname
        this.infoData.kfname = row.kfname
        this.infoData.orderamount = row.orderamount
        this.infoData.factory = this.infoData.afterSale.factory
        this.infoData.deptRson = this.infoData.afterSale.reasonList
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
      this.infoVisible = true
    },
  }
}
</script>

<style lang="scss" scoped>
.summary-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
